/**
 * The `ws` i18n namespace — every string of the workshop v2 experience lives here, never in
 * locales/<lng>/translation.json.
 *
 * Each module's strings are a JSON file per language (workshop/i18n/<module>.<lng>.json) WITHOUT the module prefix;
 * registering nests them under it, so `home.ar.json` → { "queue": { "title": "…" } } is read as
 * t('home.queue.title') with useWsT() (i18n/useWsT.ts), or t('ws:home.queue.title') from any other t().
 */
import i18n from '../../i18n';

export const WS_NS = 'ws';

type Bundle = Record<string, unknown>;

const done = new Set<string>();

/** Add one module's strings (both languages) to the `ws` namespace. Idempotent. */
export function registerWsModule(module: string, ar: Bundle, en: Bundle): void {
  if (done.has(module)) return;
  done.add(module);
  i18n.addResourceBundle('ar', WS_NS, { [module]: ar }, true, true);
  i18n.addResourceBundle('en', WS_NS, { [module]: en }, true, true);
}
